import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import Header from "../component/Header";
import Footer from "../component/Footer"
import { useForm } from "react-hook-form";
import { LoginAction, GoogleLoginAction } from "../action";
import toast, { Toaster } from 'react-hot-toast';
import LoginPopup from "./LoginPopup"
import { GoogleOAuthProvider } from '@react-oauth/google';
// import FacebookLoginButton from './Common/FacebookLoginBtn';
import GoogleLoginButton from './Common/GoogleLoginBtn';

import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Toasts from './Common/Toasts';

const clientId = process.env.REACT_APP_GOOGLE_API_KEY;

export default function Login() {
  const loginPopUpMsg = useSelector(state => state.productData.loginPopMsg)
  const loginUsers = useSelector(state => state.productData.users)
  const loginAttempted = useRef(false);

  const notify = () => toast.success('Jeni kyqur me sukses');
  const notifyErr = () => toast.error('emri i përdoruesit ose fjalëkalimi nuk përputhen');
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors } } = useForm();
  const obj = {}
  const [inputField, setInputField] = useState(obj)
  const inputsHandler = (e) => {
    console.log(e.target.name)
    let name = e.target.name;
    let value = e.target.value;
    inputField[name] = value;
    setInputField(inputField);
  }

  // const handleFacebookResponse = (response) => {
  //   console.log('Facebook login response:', response);
  // };



  const handleGoogleResponse = async (response) => {
    loginAttempted.current = true;
    try {
      const res = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
        headers: {
          Authorization: `Bearer ${response.access_token}`,
        },
      });

      const userInfo = await res.json();

      dispatch(GoogleLoginAction({
        email: userInfo.email,
        gtoken: response.access_token,
        googleid: userInfo.sub,
        fname: userInfo.given_name,
        lname: userInfo.family_name,
      }));
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };


  const checkoutData = (datax) => {
    loginAttempted.current = true;
    var data = {
      password: datax.password,
      email: datax.email,
    };
    dispatch(LoginAction(data))
  }

  useEffect(() => {
    if (loginUsers?.token?.length > 0) {
      navigate('/');
      return;
    }

    if (loginPopUpMsg) {
      notify();
      setTimeout(() => { navigate(-1) }, 2000);
      return;
    }

    if (!loginAttempted.current) return;

    if (loginUsers?.message && !loginUsers?.token) {
      notifyErr();
      loginAttempted.current = false;
    }
  }, [loginPopUpMsg, loginUsers])

  return (
    <>
      <div className="min-h-screen bg-white flex flex-col">
        <Header className="bg-white text-black" />
        <Toasts />
        <main className="flex-grow flex items-center justify-center px-4 pt-10 pb-10">
          <div className="w-full max-w-md bg-white backdrop-blur-lg shadow-[0_8px_30px_rgba(0,0,0,0.08)] rounded-2xl p-8 sm:p-10">

              <h2 className="text-3xl sm:text-4xl font-bold mb-6 text-center text-black">Kyqu në Llogari</h2>
              <form onSubmit={handleSubmit(checkoutData)} className="space-y-5">
                <div>
                  <input
                    type="text"
                    placeholder="Email"
                    name="email"
                    {...register("email", { required: true })}
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-black/20 shadow-sm bg-white text-black"
                  />
                  {errors.email && <p className="text-red-600 text-sm mt-1">Email është i detyrueshëm</p>}
                </div>

                <div>
                  <input
                    type="password"
                    placeholder="Fjalëkalimi"
                    name="password"
                    {...register("password", { required: true })}
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-black/20 shadow-sm bg-white text-black"
                  />
                  {errors.password && <p className="text-red-600 text-sm mt-1">Fjalëkalimi është i detyrueshëm</p>}
                </div>

                <div className="text-right">
                  <Link to="/reset-password" className="text-sm text-gray-700 hover:underline">Keni harruar fjalëkalimin?</Link>
                </div>

                <button
                  type="submit"
                  className="w-full bg-black hover:bg-neutral-800 transition text-white py-3 rounded-xl font-semibold shadow-md"
                >
                  Kyqu
                </button>
              </form>

              <div className="mt-6 text-center text-sm text-gray-700">Ose</div>
              <div className="w-full mt-4">
                <GoogleOAuthProvider clientId={clientId}>
                  <GoogleLoginButton onSuccess={handleGoogleResponse} />
                </GoogleOAuthProvider>
              </div>

              <div className="mt-6 text-center text-sm text-gray-700">
                Nuk keni llogari?{' '}
                <Link to="/signup" className="hover:underline font-medium text-black">
                  Regjistrohu
                </Link>
              </div>
          </div>
        </main>
        <Footer className="bg-white text-black" />
      </div>



      {/* <div className="min-h-screen bg-gradient-to-br from-indigo-100 to-blue-200 flex flex-col">
        <Header />
        <Toasts />
        <main className="flex-grow flex items-center justify-center px-4 pt-20 pb-10">
          <div className="w-full max-w-4xl bg-white bg-opacity-90 backdrop-blur-lg shadow-2xl rounded-2xl p-8 sm:p-12 flex flex-col sm:flex-row space-y-10 sm:space-y-0 sm:space-x-10 mt-24">

            <div className="flex-1">
              <h2 className="text-3xl sm:text-4xl font-bold mb-6 text-center text-indigo-800">Kyqu në Llogari</h2>
              <form onSubmit={handleSubmit(checkoutData)} className="space-y-5">
                <div>
                  <input
                    type="text"
                    placeholder="Email"
                    name="email"
                    {...register("email", { required: true })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
                  />
                  {errors.email && <p className="text-red-500 text-sm mt-1">Email është i detyrueshëm</p>}
                </div>

                <div>
                  <input
                    type="password"
                    placeholder="Fjalëkalimi"
                    name="password"
                    {...register("password", { required: true })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
                  />
                  {errors.password && <p className="text-red-500 text-sm mt-1">Fjalëkalimi është i detyrueshëm</p>}
                </div>

                <div className="text-right">
                  <Link to="/reset-password" className="text-sm text-indigo-600 hover:underline">Keni harruar fjalëkalimin?</Link>
                </div>

                <button
                  type="submit"
                  className="w-full bg-indigo-600 hover:bg-indigo-700 transition text-white py-3 rounded-xl font-semibold text-lg shadow-md"
                >
                  Kyqu
                </button>
              </form>

              <div className="mt-6 text-center text-sm text-gray-600">Ose kyquni me</div>
              <div className="flex justify-center gap-4 mt-4">
                <FacebookLoginButton onSuccess={handleFacebookResponse} />
                <GoogleOAuthProvider clientId={clientId}>
                  <GoogleLoginButton onSuccess={handleGoogleResponse} />
                </GoogleOAuthProvider>
              </div>
            </div>

            <div className="flex-1 bg-indigo-50 rounded-xl p-6 sm:p-10 flex flex-col justify-between shadow-inner">
              <div>
                <h2 className="text-2xl font-semibold mb-4 text-indigo-900">Krijoni Llogari</h2>
                <p className="text-sm text-gray-700 leading-relaxed">
                  Thjeshtoni procesin e blerjes duke krijuar një llogari. Ju nevojiten vetëm disa informacione personale.
                </p>
              </div>
              <Link
                to="/signup"
                className="mt-6 block text-center bg-black text-white py-3 rounded-xl font-semibold hover:bg-gray-800"
              >
                Regjistrohu
              </Link>
            </div>
          </div>
        </main>
        <Footer />
      </div> */}
    </>
  )
}